import React, { useEffect, useState } from 'react';
import { MenuItem, Select } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Status } from '../../../../common/constants';

const StatusFilter = (props) => {
  const [selectedStatus, setSelectedStatus] = useState(props.selectedStatus);

  const handleChange = (e) => {
    const val = e.target.value;
    setSelectedStatus(val);
    props.onFilterChanged(props.columnDef.id, val);
  };

  useEffect(() => {
    setSelectedStatus(props.selectedStatus);
  }, [props.selectedStatus]);

  return (
    <Select
      className="w-100"
      disabled
      value={selectedStatus}
      onChange={handleChange}
    >
      <MenuItem value="">-</MenuItem>
      <MenuItem value={Status.Activated}>{Status.Activated}</MenuItem>
      <MenuItem value={Status.Unredeemed}>{Status.Unredeemed}</MenuItem>
      <MenuItem value={Status.Redeemed}>{Status.Redeemed}</MenuItem>
      <MenuItem value={Status.Deactivated}>{Status.Deactivated}</MenuItem>
    </Select>
  );
};

StatusFilter.defaultProps = {
  selectedStatus: Status.Unredeemed,
};

StatusFilter.propTypes = {
  onFilterChanged: PropTypes.func.isRequired,
  columnDef:       PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  selectedStatus: PropTypes.oneOf([
    '',
    Status.Activated,
    Status.Unredeemed,
    Status.Redeemed,
    Status.Deactivated,
  ]),
};

export default StatusFilter;
